import $app from 'app/stores/$app';
import Collection from 'core/model/Collection';
import Subscription from './Subscription';

class SubscriptionCollection extends Collection {
  get url() {
    return '/api/ui/subscriptions/';
  }

  get model() {
    return Subscription;
  }

  get filterFieldWhitelist() {
    return new Set(['title', 'recipients']);
  }

  async fetch(options = {}) {
    if ($app.isSubtenant) {
      return Promise.resolve();
    }

    return super.fetch(options);
  }
}

export default SubscriptionCollection;
